import { render, staticRenderFns } from "./FinalCenter.vue?vue&type=template&id=db84a496&lang=html"
import script from "./FinalCenter.vue?vue&type=script&lang=js"
export * from "./FinalCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports